module.exports = __webpack_public_path__ + "static/img/onlinec.276a375.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/onlinec.jpg
 ** module id = 598
 ** module chunks = 2
 **/